module.exports = __webpack_public_path__ + "img/pricecard-trial.cceafb07.png";